import React, { ChangeEvent, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormSelect,
  CRow,
  CTabContent,
} from '@coreui/react-pro'
import { useCreateBudgetItem } from './hooks'
import { setBudgetItem, submitCreateBudgetItem } from './model'

export const CreateBudgetItem = () => {
  const [validated, setValidated] = useState(false)

  const { budgetItem, section } = useCreateBudgetItem()

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value = event.currentTarget.value

    setBudgetItem({
      ...budgetItem,
      [event.currentTarget.name]: value,
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitCreateBudgetItem(budgetItem)
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Create budget item</strong>
      </CCardHeader>
      <CCardBody>
        <CTabContent className="pt-3">
          <CForm noValidate validated={validated} onSubmit={handleSubmit}>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="name"
                  name="name"
                  value={budgetItem.name}
                  onChange={handleChange}
                  label="Name"
                  required
                />
              </CCol>
              <CCol sm={4}>
                <CFormSelect
                  id="section"
                  name="section"
                  value={budgetItem.section}
                  onChange={handleChange}
                  label="Section"
                  required
                >
                  <option value="">Choose section</option>
                  {section.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.name}
                    </option>
                  ))}
                </CFormSelect>
              </CCol>
            </CRow>
            <CButton className="mb-3" type="submit">
              Create
            </CButton>
          </CForm>
        </CTabContent>
      </CCardBody>
    </CCard>
  )
}
